export default "__VITE_ASSET__BvgmvtFb__"